import { useQuery } from '@tanstack/react-query';
import { fetchAnalyticsOverview } from '@/services/analytics';

const ANALYTICS_OVERVIEW_KEY = ['admin', 'analytics', 'overview'];

export function useAnalyticsOverview() {
  return useQuery({
    queryKey: ANALYTICS_OVERVIEW_KEY,
    queryFn: fetchAnalyticsOverview,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
